<script>
import GridBase from './GridBase.vue';
export default {
  name: 'SimpleGrid',
  extends: GridBase,
  props: {
    layout: Array
  },
  methods: {
    loadData: function (metadata, data) {
      const self = this;
      var mapped = self.layout.filter(x => {
        if (metadata.find(m => m.FieldName === x.FieldName)) {
          return x;
        }
      }).map(x => {
        let meta = metadata.find(m => m.FieldName === x.FieldName);
        if (meta != null) {
          let newObj = Object.assign(meta, x);
          return newObj;
        } else {
          console.info('meta not found for field ', x);
        }
      });
      self.innerColumns = mapped;
      self.innerRows = data;
      self.rowMetaData = data.map(x => {
        return {
          index: data.indexOf(x),
          selected: false
        };
      });
    }
  }
};
</script>
